import {AxiosError} from 'axios';

import {ApiErrorResponse} from 'src/types';

// TODO: We should not allow T to be set, since an error response should be consistent
// but currently the response isn't consistent.
export const isAxiosError = <T = ApiErrorResponse>(error: unknown): error is AxiosError<T> =>
  error instanceof Error && !!(error as Error & {isAxiosError: boolean})['isAxiosError'];
